/**
 * accountMappingCache (P3, Feb 2026)
 *
 * Module-Level Cache für SB-Account-Mappings (1 API-Call pro Mandant pro Session).
 * Wird vom CategoryHint-Tooltip im SB-Belege-View genutzt, damit pro Zeile keine
 * separate API-Anfrage notwendig ist.
 *
 * Cache-Invalidation: ``invalidate(clientId)`` nach Mapping-Änderung im AccountMappingTab.
 */
import axios from 'axios';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const cache = new Map();
const inflight = new Map();

const H = (token) => ({ Authorization: `Bearer ${token}` });

export async function getAccountMapping(clientId, advisorToken) {
  if (!clientId || !advisorToken) return null;
  if (cache.has(clientId)) return cache.get(clientId);
  if (inflight.has(clientId)) return inflight.get(clientId);
  const p = axios.get(`${API}/advisor/clients/${clientId}/account-mapping`, { headers: H(advisorToken) })
    .then(r => {
      cache.set(clientId, r.data);
      inflight.delete(clientId);
      return r.data;
    })
    .catch(e => {
      inflight.delete(clientId);
      throw e;
    });
  inflight.set(clientId, p);
  return p;
}

export function invalidateAccountMapping(clientId) {
  if (clientId) cache.delete(clientId);
  else cache.clear();
}
